<template>
  <div class="layout--full-page">
    <div
      class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
      id="page-login"
    >
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
        <vx-card>
          <div slot="no-body" class="full-page-bg-color">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col hidden lg:block lg:w-1/2">
                <img src="/logo.png" alt="login" class="mx-auto" width="170px" />
              </div>
              <!-- https://api.pelayanan-publik.badungkab.go.id/storage/complaints/1674103746/NBr1A4cs0vy2Eg2MA7RxCmVFU1py4CPaHNl0nFMS.jpg -->

              <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                <div class="p-8 login-tabs-container">
                  <div class="vx-card__title mb-4">
                    <h4 class="mb-4">Masuk ke Portal Petugas Pelayanan Publik</h4>
                  </div>

                  <div>
                    <vs-input
                      :danger="error.username.status"
                      :danger-text="error.username.text"
                      name="username"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      label-placeholder="Username"
                      v-model="authData.username"
                      val-icon-danger="icon-x"
                      val-icon-pack="feather"
                      class="w-full"
                      v-on:keyup.enter="login"
                    />

                    <vs-input
                      type="password"
                      name="password"
                      :danger="error.password.status"
                      :danger-text="error.password.text"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Password"
                      v-model="authData.password"
                      val-icon-danger="icon-x"
                      val-icon-pack="feather"
                      class="w-full mt-6"
                      v-on:keyup.enter="login"
                    />

                    <!-- <div class="flex flex-wrap justify-between my-5">
                      <router-link to>Forgot Password?</router-link>
                    </div> -->
                    <br>
                    <div class="flex justify-end">
                      <vs-button class="self-end" @click="login">Login</vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      authData: {
        username: "",
        password: ""
      },
      error: {
        username: {
          status: false,
          text: ""
        },
        password: {
          status: false,
          text: ""
        }
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    let token = localStorage.getItem("_token");
    let type = localStorage.getItem("_auth_type");
    if (token && type) {
      next({ name: "home" });
    }
    next();
  },
  methods: {
    login() {
      this.$vs.loading();
      this.$http
        .post("/app/secure/auth/login", this.authData)
        .then(r => {
          let payload = r.data.data.auth;
          this.$store.dispatch("updateUserInfo", payload).then(() => {
            this.$store.dispatch("setAuthToken", r.data.data.token).then(() => {
              this.$store.dispatch("setAuthType", "user").then(() => {
                this.$store
                  .dispatch("setUserAgent", r.data.data.user_agent)
                  .then(() => {
                    this.$router.push({ name: "secure-home" });
                  });
              });
            });
          });
        })
        .catch(e => {
          if (e.response.status == 422) {
            let error = e.response.data.data.error;
            this.setMessageError(error);
          } else {
            alert(e);
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    setMessageError(error) {
      for (var key in error) {
        if (!error.hasOwnProperty(key)) continue;
        let msgs = error[key];
        this.error[key].text = msgs.join(". ");
        this.error[key].status = true;
      }
    },
    removeMessageError(val = null) {
      if (val) {
        this.error[val].status = false;
        this.error[val].text = "";
      } else {
        for (var key in this.error) {
          this.error[key].status = false;
          this.error[key].text = "";
        }
      }
    }
  },
  watch: {
    authData: {
      handler: function() {
        this.removeMessageError();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
